"use strict";
const focusRing = "_focusRing_giofa_3";
const focus = {
  focusRing
};
exports.focus = focus;
